import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ExplevelFilterCriteria from './ExplevelFilterCriteria'
import ExplevelList from './ExplevelList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ExplevelAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setExplevelDashboardExplevelList } from '../../store/slice/ManufSlice';

export default function ExplevelListView({setShowEdit,setExplevelId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.explevelDashboard);   

    const [filteredExplevelList, setFilteredExplevelList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { explevelDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (explevelDashboard.explevelList.length>-1){
        setFilteredExplevelList(explevelDashboard.explevelList);
        transformToCardFormat(explevelDashboard.explevelList, setCardList);
      }
    },[explevelDashboard.explevelList])

    useEffect(()=>{
          transformToCardFormat(filteredExplevelList, setCardList);
      },[filteredExplevelList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredExplevelList(explevelDashboard.explevelList);
            transformToCardFormat(explevelDashboard.explevelList, setCardList);

        } else {
            setFilteredExplevelList(
                explevelDashboard.explevelList
                    .filter(explevel=> explevel.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(explevelDashboard.filteredExplevelList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ExplevelList
                    setShowEdit={setShowEdit}
                    setExplevelId = {setExplevelId}
                    tableList={filteredExplevelList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}